import Splide from '@splidejs/splide'

document.addEventListener('DOMContentLoaded', function (e) {
  const projectsBlock = e.target.querySelector('.projects__block')

  if (projectsBlock) {
    const jsProjectsSlider = projectsBlock.querySelector('.js-projects-slider')

    if (jsProjectsSlider) {
      const setSplide = () => {
        const splideInstance = new Splide(jsProjectsSlider, {
          perPage: 3,
          perMove: 1,
          gap: '20px',
          arrows: false,
          pagination: false,

          breakpoints: {
            667: {
              perPage: 1,
              fixedWidth: '320px',
              gap: '10px',
            },
            996: {
              fixedWidth: '355px',
              perPage: 2,
              gap: '20px',
            },
          },
        })
        splideInstance.mount()
      }

      window.addEventListener('load', setSplide)
      window.addEventListener('resize', setSplide)
    }
  }
})
